var valueOf = 1.0.valueOf; // `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue

module.exports = function (value) {
  return valueOf.call(value);
};